import React from 'react'
import PropTypes from 'prop-types'

import InputGroup from '../EmailSubscriptionCenter/SignIn/InputGroup.jsx'

function AdditionalInformation({
  compact,
  handleInputChange,
  handleFirmInputChange,
  maskedPhoneNbr,
  formValidation,
  formData,
  firms,
}) {
  function renderFirms() {
    return firms.length > 0 ? (
      <datalist id="firms">
        {firms.map((firm, index) => {
          return <option value={firm.firmNm} key={'' + index + firm.firmId} />
        })}
      </datalist>
    ) : null
  }

  return (
    <div className="u-sm-sizeFull">
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="firstNameLegal"
        fieldId="firstNameLegal"
        placeholder="Legal first name"
        label="Legal first name"
        compact={compact}
      />
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="firstName"
        fieldId="firstName"
        placeholder="Preferred first name"
        label="Preferred first name"
        compact={compact}
      />
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="lastName"
        fieldId="lastName"
        placeholder="Last name"
        label="Last name"
        compact={compact}
      />
      <InputGroup
        handleInputChange={handleFirmInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="firmName"
        fieldId="firmName"
        placeholder="Firm name"
        label="Firm name"
        list="firms"
        compact={compact}
      />
      {renderFirms()}
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="zipCode"
        fieldId="zipCode"
        placeholder="ZIP code"
        label="ZIP code"
        compact={compact}
      />
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="phoneNumber"
        fieldId="phoneNumber"
        placeholder="_ _ _ . _ _ _ . _ _ _ _"
        label="Phone number"
        maskedValue={maskedPhoneNbr}
        compact={compact}
      />
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="emailId"
        fieldId="emailId"
        placeholder="Email"
        label="Email"
        compact={compact}
        disabled={true}
      />
    </div>
  )
}

AdditionalInformation.propTypes = {
  compact: PropTypes.bool,
  handleInputChange: PropTypes.func.isRequired,
  handleFirmInputChange: PropTypes.func.isRequired,
  formValidation: PropTypes.object,
  firms: PropTypes.array,
}

export default AdditionalInformation
